export default __webpack_public_path__ + "static/media/snow-2-day.5a131496.svg";